import { getRequest, } from '@/request/request';
// 权限菜单
export const getRightLists = (url:string) :any => getRequest(url);
// 角色权限菜单
export const getRoleRightLists = () :any => getRequest('/menu/menuList');
